import { instantiateOrgPortal } from "@api/Billing";
import { DSButton } from "@components/design-system/molecules";
import { faCreditCard } from "@fortawesome/pro-solid-svg-icons";
import { useOrganization } from "@hooks";
import { useState } from "react";

import { ConfirmSetupBillingModal } from "./ConfirmSetupBillingModal";

export const OrgBillingInfo = ({ hasBillingSetup }) => {
  const { isOrgAdmin } = useOrganization();

  const [
    shouldShowConfirmSetupBillingModal,
    setShouldShowConfirmSetupBillingModal,
  ] = useState(false);

  if (!isOrgAdmin) {
    return null;
  }

  return (
    <>
      <ConfirmSetupBillingModal
        shouldShow={shouldShowConfirmSetupBillingModal}
        setShouldShow={setShouldShowConfirmSetupBillingModal}
      />
      {hasBillingSetup ? (
        <DSButton
          onClick={() => {
            instantiateOrgPortal();
          }}
          variant="primary"
          icon={faCreditCard}
          dataTestId="view-billing-info-button"
        >
          View Billing Info
        </DSButton>
      ) : (
        <DSButton
          onClick={() => setShouldShowConfirmSetupBillingModal(true)}
          variant="primary"
          icon={faCreditCard}
          dataTestId="setup-billing-button"
        >
          Set Up Billing
        </DSButton>
      )}
    </>
  );
};
